module.exports = __webpack_public_path__ + "img/logo1.992d73bb.png";